module.exports = __webpack_public_path__ + "545848580a4d5852c2ef47d198e4e2ad.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_SymbolS_Square_Off_White_Big_RGB.png
// module id = 289
// module chunks = 0